import { render, staticRenderFns } from "./LocalizarAssociacao.vue?vue&type=template&id=6e487a9a"
import script from "./LocalizarAssociacao.vue?vue&type=script&lang=ts"
export * from "./LocalizarAssociacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports